import { render } from "./CollectionCardsModule.vue?vue&type=template&id=368e0d1e&scoped=true"
import script from "./CollectionCardsModule.vue?vue&type=script&lang=js"
export * from "./CollectionCardsModule.vue?vue&type=script&lang=js"

import "./CollectionCardsModule.vue?vue&type=style&index=0&id=368e0d1e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368e0d1e"]])

export default __exports__